import { environment } from 'src/environments/environment';

// TODO: Update this class name - low
export class Config {
    static allowedDomains = [];

    static apisWithoutHeader = [
        'refund',
        'guest',
        'login',
        'downloadInvoicesByConfirmationId',
        'searchFacilities',
        environment.uris.method.payments + '/company',
        'preValidatePaymentRequest',
        'isValidCostCenter',
        'awbDuplicateCount',
        'downloadExternalReceipt',
        'approveMultiplePaymentRequests',
        'approvePaymentRequest',
        'editApprovalPaymentRequest',
        'cancelPaymentRequest',
        'addOpenInvoicesToCart',
        'countries',
        'activate',
        'compress',
        'recoverPassword',
        'logoff',
        'validateActivationKey',
        'recoverWithActivationKey',
        'sso/redirecturl',
        'maps/api',
        '/customer-profile',
    ];

    static apisWithoutContentType = [
        '/uploadPaymentRequests',
        '/megaFileUpload',
        'bulk/startApprovalFlow',
        'bulk',
        'refund',
        'guest',
        'login',
        'downloadInvoicesByConfirmationId',
        'searchFacilities',
        'company',
        'preValidatePaymentRequest',
        'isValidCostCenter',
        'awbDuplicateCount',
        'downloadExternalReceipt',
        'approveMultiplePaymentRequests',
        'approvePaymentRequest',
        'editApprovalPaymentRequest',
        'cancelPaymentRequest',
        'addOpenInvoicesToCart',
        'countries',
        'activate',
        'compress',
        'recoverPassword',
        'logoff',
        'validateActivationKey',
        'recoverWithActivationKey',
        'sso/redirecturl',
        'maps/api',
        '/customer-profile',
    ];

    static apisWithoutAccessControl = [
        '/uploadPaymentRequests',
        '/megaFileUpload',
        'bulk/startApprovalFlow',
        'bulk',
        'refund',
        'guest',
        'login',
        'downloadInvoicesByConfirmationId',
        'searchFacilities',
        'company',
        'preValidatePaymentRequest',
        'isValidCostCenter',
        'awbDuplicateCount',
        'downloadExternalReceipt',
        'approveMultiplePaymentRequests',
        'approvePaymentRequest',
        'editApprovalPaymentRequest',
        'cancelPaymentRequest',
        'addOpenInvoicesToCart',
        'countries',
        'activate',
        'compress',
        'recoverPassword',
        'logoff',
        'validateActivationKey',
        'recoverWithActivationKey',
        'sso/redirecturl',
        'maps/api',
        '/customer-profile',
    ];
}
